import React, { useEffect, useState, useRef, useMemo, forwardRef } from "react";
import { Segment, Container, Divider, Button, DimmerDimmable, Dimmer } from "semantic-ui-react";
import ApiSale from "../../core/api/api.sale";
import { CirclesWithBar } from "react-loader-spinner";
import { useNavigate, useParams } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import ServiceNotification from "../../core/services/services.notification";
import SellContractHeader from "../../components/SellContractPrinter/SellContractHeader";
import InvoiceProductsGrid from "../../components/SellInvoicePrinter/InvoiceProductsGrid";

const SaleContract = forwardRef(function ({ saleid }, ref) {
  const sigref = useRef();
  const [mydata, setData] = useState({});
  const [showSigText, setShowSigText] = useState(true);
  const { saleidParam } = useParams();

  const [signatureData, setSigData] = useState({
    id: null,
    slug: null,
    contract: null,
  });
  const [expired, setExpired] = useState(false);

  const navigate = useNavigate();
  const [noData, setNoData] = useState(false);
  const [logosrc, setLogo] = useState("");
  const [seal, setSeal] = useState("");
  const [contractForm, setContractForm] = useState("");
  const [showProducts, setShowProducts] = useState(false);

  const getSaleById = async () => {
    try {
      const res = await ApiSale.getPublicSaleById(
        saleid ? saleid : saleidParam
      );
      if (res.data.status == "success") {
        if(saleidParam){
          const expireDate = new Date(res.data?.data?.sale?.expiredate);
          const now = new Date();
          if (expireDate < now || res.data?.data?.sale?.status == 4) {
            setExpired(true);
          }
        }
        setSigData({
          id: res.data.data.sale.id,
          slug: res.data.data.sale.slug,
          contract: null,
        });
        let temp = res.data.data;
        let totalCount = 0;
        temp.totalCount = totalCount;
        setData(res.data.data);

        let index = res.data.data.settings.findIndex(
          (item) => item.name == "logo"
        );
        if (index > -1) {
          setLogo(res.data.data.settings[index].value);
        }

        let indexSeal = res.data.data.settings.findIndex(
          (item) => item.name == "companySeal"
        );
        if (indexSeal > -1) {
          setSeal(res.data.data.settings[indexSeal].value);
        }
      } else {
        setNoData(res.data.message);
      }
    } catch (e) {
      console.log(e);
      if (e && e.response && e.response.status == 401) {
        navigate("/login");
      }
    }
  };

  useEffect(() => {
    if (saleid || saleidParam) {
      getSaleById(saleid);
    }
  }, [saleid]);

  const initContractform = useMemo(() => {
    // tokens
    if (mydata && Object.keys(mydata).length > 0) {
      const tokens = [
        {
          name: "publicNumber",
          value: mydata.sale.publicNumber
            ? mydata.sale.publicNumber
            : mydata.sale.id,
        },
        {
          name: "expiredate",
          value:
            mydata?.sale?.expiredate &&
            new Date(mydata.sale.expiredate).toLocaleDateString("fa"),
        },
        {
          name: "insertdate",
          value:
            mydata?.sale?.insertdate &&
            new Date(mydata.sale.insertdate).toLocaleDateString("fa"),
        },
        {
          name: "vendorName",
          value: mydata?.settings.find((item) => item.name == "vendorName")
            ?.value,
        },
        {
          name: "vendorCompany",
          value: mydata?.settings.find((item) => item.name == "vendorCompany")
            ?.value,
        },
        {
          name: "vendorEconomyCode",
          value: mydata?.settings.find(
            (item) => item.name == "vendorEconomyCode"
          )?.value,
        },
        {
          name: "vendorCountry",
          value: mydata?.settings.find((item) => item.name == "vendorCountry")
            ?.value,
        },
        {
          name: "vendorProvince",
          value: mydata?.settings.find((item) => item.name == "vendorProvince")
            ?.value,
        },
        {
          name: "vendorCity",
          value: mydata?.settings.find((item) => item.name == "vendorCity")
            ?.value,
        },
        {
          name: "vendorPostalCode",
          value: mydata?.settings.find(
            (item) => item.name == "vendorPostalCode"
          )?.value,
        },
        {
          name: "vendorNationCode",
          value: mydata?.settings.find(
            (item) => item.name == "vendorNationCode"
          )?.value,
        },
        {
          name: "vendorPhone",
          value: mydata?.settings.find((item) => item.name == "vendorPhone")
            ?.value,
        },
        {
          name: "vendorMobile",
          value: mydata?.settings.find((item) => item.name == "vendorMobile")
            ?.value,
        },
        {
          name: "vendorAddress",
          value: mydata?.settings.find((item) => item.name == "vendorAddress")
            ?.value,
        },
        {
          name: "nicname",
          value: mydata?.sale?.contact?.nicname || "",
        },
        {
          name: "company",
          value: mydata?.sale?.contact?.company || "",
        },
        {
          name: "ecode",
          value: mydata?.sale?.contact?.ecode || "",
        },
        {
          name: "province",
          value: mydata?.sale?.contact?.province || "",
        },
        {
          name: "city",
          value: mydata?.sale?.contact?.city || "",
        },
        {
          name: "postalcode",
          value: mydata?.sale?.contact?.postalcode || "",
        },
        {
          name: "natode",
          value: mydata?.sale?.contact?.natode || "",
        },
        {
          name: "phone",
          value: mydata?.sale?.contact?.phone || "",
        },
        {
          name: "mobile",
          value: mydata?.sale?.contact?.mobile || "",
        },
        {
          name: "address",
          value: mydata?.sale?.contact?.address || "",
        },
        {
          name: "totalprice",
          value:
            mydata?.sale?.totalprice &&
            Number(mydata.sale.totalprice).toLocaleString(),
        },
        {
          name: "totaldiscount",
          value:
            mydata?.sale?.totaldiscount &&
            Number(mydata.sale.totaldiscount).toLocaleString(),
        },
        {
          name: "comment",
          value: mydata.sale.comment,
        },
      ];

      let indexContract = mydata.settings.findIndex(
        (item) => item.name == "contractForm"
      );
      if (indexContract > -1) {
        let temp = mydata.settings[indexContract].value;
        for (let i in tokens) {
          temp = temp.replace(tokens[i].name, tokens[i].value);
        }
        if(temp.includes("showProducts") == true){
          setShowProducts(true);
          temp = temp.replace("showProducts", "");

        }
        setContractForm(temp);
      }

   
    }
  }, [mydata]);

  const saveSignatureHandler = async (e) => {
    e.target.classList.add("loading");
    if (
      signatureData.id != null &&
      signatureData.slug != null &&
      signatureData.contract != null
    ) {
      try {
        const res = await ApiSale.saveContractSignature(signatureData);
        if (res.data.status == "success") {
          ServiceNotification.show(
            "",
            res.data.message,
            res.data.status == "success" ? "success" : "danger"
          );
          getSaleById();
        }
      } catch (e) {
        console.log(e);
        if (e && e.response && e.response.status == 401) {
          navigate("/login");
        }
      }
    } else {
      ServiceNotification.show("", "امضا یافت نشد", "warning");
    }
    e.target.classList.remove("loading");
  };

  const onSignEnd = (e) => {
    setShowSigText(false);
    setSigData((prevState) => ({
      ...prevState,
      contract: sigref.current.toDataURL("png"),
    }));
    document.getElementById("signature-input").value = "";
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      sigref.current.clear();
      const img = new Image();
      img.src = reader.result;

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const maxWidth = 300; // Maximum width for the resized image
        const maxHeight = 300; // Maximum height for the resized image
        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        const resizedBase64 = canvas.toDataURL("image/png");
        setSigData((prevState) => ({
          ...prevState,
          contract: resizedBase64,
        }));
      };
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const clearSignature = () => {
    setShowSigText(true);
    sigref.current.clear();
  };

  return noData == false ? (
    mydata && Object.keys(mydata).length > 0 && logosrc != "" ? (
      <div ref={ref}>
        <div>
        <DimmerDimmable blurring dimmed={expired}>
          <Dimmer active={expired} style={{justifyContent:'flex-start'}}>
            <div className="ui header large inverted" style={{marginTop:'200px'}}>اعتبار این {mydata?.sale?.status == 1 ? "پیش فاکتور" : "فاکتور"} تمام شده است</div>
            <div className="ui header inverted">با شماره 02145705 تماس بگیرید</div>
          </Dimmer>
        
        <Container className="bg-white ">
          <Segment basic id="saleview">
            <SellContractHeader mydata={mydata} logosrc={logosrc} />
            <p></p>
            <Divider className="bold" />
            <div className="contract-container">
              <div dangerouslySetInnerHTML={{ __html: contractForm }} />
              {showProducts == true && (
                <div style={{ padding: "1em" }}>
                  <InvoiceProductsGrid mydata={mydata} />
                </div>
              )}

              <Divider hidden />

              <div
                className="d-flex flow-row"
                style={{ justifyContent: "space-around" }}
              >
                <div className="d-flex flow-col ai-center">
                  <p style={{ borderBottom: "1px solid" }}>امضای مشتری</p>

                  {mydata.sale.contract && mydata.sale.contract.length > 0 ? (
                    <div style={{ width: "150px" }}>
                      <img
                        style={{ margin: "auto" }}
                        src={mydata.sale.contract}
                        className="ui image large"
                      />
                    </div>
                  ) : (
                    <div className="w-100 text-center position-relative">
                      <div
                        style={{
                          display: `${showSigText == true ? "block" : "none"}`,
                        }}
                        className="sigcanvas-text"
                      >
                        <p>
                          محل امضا
                          <br />
                          <br />
                          (از طریق صفحه لمسی تلفن همراه خود بصورت دیجیتال امضا
                          بفرمایید)
                        </p>
                      </div>
                      <SignatureCanvas
                        ref={sigref}
                        onBegin={() => setShowSigText(false)}
                        onEnd={() => onSignEnd()}
                        penColor="#000ad8"
                        canvasProps={{
                          width: 150,
                          height: 150,
                          className: "sigCanvas border-grey",
                          zIndex: "1",
                          position: "relative",
                        }}
                      />

                      <Divider hidden />
                      <input
                        label="انتخاب"
                        onChange={(e) => handleImageUpload(e)}
                        type="file"
                        accept="image/*"
                        id="signature-input"
                      />
                      <Divider hidden />
                      <div className="d-flex flow-row ai-center jc-center">
                        <Button size="mini" onClick={(e) => clearSignature()}>
                          پاک کردن
                        </Button>
                        <Button
                          size="mini"
                          color="green"
                          onClick={(e) => saveSignatureHandler(e)}
                        >
                          ذخیره
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
                <div className="d-flex flow-col ai-center">
                  <p style={{ borderBottom: "1px solid" }}>
                    مهر و امضای فروشنده
                  </p>
                  <div
                    style={{
                      display: "flex",
                      flexFlow: "row-reverse",
                      justifyContent: "center",
                    }}
                  >
                    <img src={seal} className="ui image small" />
                  </div>
                </div>
              </div>
              <Divider hidden />
            </div>
          </Segment>
        </Container>
        </DimmerDimmable>
        </div>
      </div>
    ) : (
      <CirclesWithBar
        height="150"
        width="150"
        color="#3c4856"
        wrapperStyle={{
          justifyContent: "center",
          height: "90vh",
          alignItems: "center",
        }}
        wrapperClass=""
        visible={true}
        outerCircleColor=""
        innerCircleColor=""
        barColor=""
        ariaLabel="circles-with-bar-loading"
      />
    )
  ) : (
    <div>{noData}</div>
  );
});

export default SaleContract;
